<template>
  <div v-if="media">
    <b-link :disabled="disabled"
            class="nav-link icon-share"
            @click.prevent="download()"
            v-if="quality === mediaQuality.AUTO">
      <div class="icon-bg">
        <b-spinner v-if="loading" small />
        <Icon name="download" width="26" v-else/>
      </div>
    </b-link>
    <b-button variant="primary" block v-else
              class="position-relative"
              :class="{'disabled': disabled}"
              @click="download()">{{ label }}
    </b-button>
  </div>
</template>

<script>
import {mediaQuality, servingType} from "@/domain/galleries/constants";
import {mapGetters} from "vuex";
import {downloadMedia, resolveMediaDownloadUrl} from "@/domain/galleries/medias/mediaDownload";

export default {
  emits: ['click'],
  data() {
    return {
     loading: false
    }
  },
  props: {
    quality: {
      type: String,
      required: true
    },
    media: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters('checkinDetail', [
      'hdServingType'
    ]),
    disabled() {
      return !this.mediaUrl
    },
    mediaQuality() {
      return mediaQuality;
    },

    mediaUrl() {
      return resolveMediaDownloadUrl(this.media, this.quality)
    },

    label() {
      if (this.quality === mediaQuality.SD) {
        if (this.hdServingType === servingType.DISABLED || !this.media.download_hd_url) {
          return this.$t('collage_photo_item.download')
        }
        return this.$t('collage_photo_item.sd_size')
      } else {
        if (!this.mediaUrl && this.hdServingType !== servingType.DISABLED) {
          return this.$t('collage_photo_item.download_hd_available_from')
        }
        return this.media.download_sd_url
            ? this.$t('collage_photo_item.hd_size')
            : this.$t('collage_photo_item.download')
      }
    }
  },

  methods: {
    async download() {
      if (this.disabled) return
      this.loading = true
      this.$emit('click')

      await downloadMedia(this.media, {quality: this.quality})

      this.loading = false
      return false
    },
  }
}
</script>
